export interface StorageState {
  APIConfig?: string,
  APIEndpoint?: 'account' | 'admin' | 'productDB';
  tokens: {
    access: null | {
      injectionToken?: string,
      createdTimestampInSeconds: number,
      expiredIn: number
    }
    refresh: null | {
      createdTimestampInSeconds: number,
      expiredIn: number
    }
  }
  userId: null | string;
  listConfigs: { id: string, visibleColumnFields: string[] }[];
  entryPoint: string | null;
  scopes: string[] | null
}

export const initialStorageState = (): StorageState => {
  return {
    tokens: {
      access: null,
      refresh: null
    },
    userId: null,
    listConfigs: [],
    entryPoint: null,
    scopes: null
  };
};
